// extracted by mini-css-extract-plugin
export default {"actionContainer":"companies_actionContainer__sJ0BY","contentContainer":"companies_contentContainer__z6mzF","dataGridContainer":"companies_dataGridContainer__o2Z1D"};